import { useMemo } from 'react';
import { IProgram, IProgramWithPaymentCalculation } from '../../../types/mortgage';
import { calculateMonthlyPayment } from '../utils/calculateMonthlyPayment';

interface IParams {
  price: number;
  initialPayment: number;
  paymentPeriod: number;
  programs?: IProgram[];
}

export const useMortgagePrograms = ({
  price,
  initialPayment,
  paymentPeriod,
  programs,
}: IParams): IProgramWithPaymentCalculation[] => {
  return useMemo(() => {
    if (!programs) {
      return [];
    }

    return programs
      .filter(({ creditLimitMillions, termYears }) => {
        const programPrice = creditLimitMillions * 1000000;

        return price <= programPrice && paymentPeriod <= termYears;
      })
      .map(program => ({
        ...program,
        payment: calculateMonthlyPayment({ price, initialPayment, rate: program.rate, years: paymentPeriod }),
      }));
  }, [initialPayment, paymentPeriod, price, programs]);
};
